import i18next from 'i18next';

import { getDictionaryById } from 'common/components/segment/helpers';
import alerts from 'common/modules/alerts';

import * as selectors from '../selectors';

import deleteSegment from './deleteSegment';

export default (callback, id) => (dispatch, getState) => {
    const state = getState();
    const segments = selectors.getSegmentsData(state);
    const segmentsDictionary = getDictionaryById(segments);
    const dataAlert = {
        confirmText: i18next.t('Delete'),
        messages: [
            i18next.t('Are you sure to remove the item "{{name}}"?', {
                name: segmentsDictionary[id].name,
            }),
        ],
        onSuccess: () => dispatch(deleteSegment(callback, id)),
        title: i18next.t('Confirmation'),
        type: alerts.ALERT_TYPE_CONFIRM,
        variant: 'warning',
    };

    dispatch(alerts.actions.show(dataAlert));
};
